import { useCallback } from "react";
import { Stack, Typography } from "@mui/material";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";

const HeaderDefaultCell = ({
  headerItem,
  getJustifyContent,
  getColumnLabel,
  getSortIcon,
  handleSort,
  getColumnHighlight
}: {
  headerItem: any;
  getJustifyContent: any;
  getColumnLabel: any;
  getSortIcon: any;
  handleSort: any;
  getColumnHighlight: any;
}) => {
  const { t } = useTranslation();
  const onClick = useCallback(
    () => handleSort(headerItem),
    [handleSort, headerItem]
  );
  return (
    <Stack
      direction="row"
      sx={{
        display: "flex",
        alignItems: "center",
        cursor: headerItem.isSortable ? "pointer" : "auto",
        justifyContent: getJustifyContent(headerItem.align)
      }}
      data-testid={`table-label-${headerItem.id}`}
      onClick={onClick}
    >
      <Typography
        color="grey.900"
        fontWeight={600}
        sx={{ textTransform: "uppercase", display: "flex" }}
        fontSize={headerItem.fontSize ? headerItem.fontSize : 12}
        variant="subtitle2"
        data-testid={`tableHeaders.${headerItem.id}`}
        aria-label={`${
          /* istanbul ignore next */
          t("tableHeaders." + headerItem.id).trim() === "" ? "No value" : ""
        }`}
      >
        {getColumnLabel(headerItem)}
        {getColumnHighlight(headerItem)
          ? parse(getColumnHighlight(headerItem))
          : null}
      </Typography>
      {getSortIcon(headerItem)}
    </Stack>
  );
};

export default HeaderDefaultCell;
